import React, { useState, useEffect }  from 'react';
import { Menu, MenuButton, MenuItem, MenuList, Box, Text, Flex, UnorderedList } from '@chakra-ui/react';
import { BsXLg } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { update_variant_table } from 'redux/actions/storeActions';

export default function CustomMultipleSelectDropdown({
    label,
    value,
    initiaValue = [],
    callBack = null
}) {
    if(!initiaValue) initiaValue = [];
    const [box, setBox] = useState(initiaValue);
    const [menuList, setMenuList] = useState(value);
    const dispatch = useDispatch();

    const handleClick = (e, item, i) => {
        if (label === 'Color') {
            setBox([item]);
        } else {
            setMenuList((prev) => {
                return [...prev.filter((ele) => ele !== item)];
            });

            setBox((prev) => {
                return [...prev, item];
            });
        }
    };

    const handleSingleDelete = (e, item) => {
        if (label === 'Color') {
            setBox([]);
            dispatch(update_variant_table({ name: "Color", value: [] }));
        } else {
            setBox((prev) => {
                return [...prev.filter((ele) => ele !== item)];
            });
            setMenuList((prev) => {
                return [...prev, item];
            });
        }
    };

    const handleMultipleDelete = () => {
        setMenuList([...menuList, ...box]);
        setBox([]);
    };

    useEffect(() => {
        if(callBack && box.length > 0) callBack({name: label, value: box})
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [box]);

    return (
        <Box
            border="2px solid #F2F4F7"
            display="grid"
            gridTemplateColumns="95% 5%"
            gridTemplateAreas='"menu cancel" "list list"'
            marginBottom="2rem">
            <Menu gridArea="menu">
                <MenuButton width="100%" position="relative">
                    <Flex
                        justifyContent="space-between"
                        alignItems="center"
                        width="inherit"
                        height="inherit"
                        padding=".8rem">
                        <Text display="inline">{label}</Text>
                    </Flex>
                </MenuButton>
                <MenuList
                    height={label === 'Color' ? '200px' : 'max-content'}
                    overflowY="auto"
                    overflowX="hidden">
                    {menuList.map((item, index) => (
                        <MenuItem
                            key={index}
                            onClick={(e) => handleClick(e, item, index)}
                            margin=".5rem">
                            {item}
                        </MenuItem>
                    ))}
                </MenuList>
            </Menu>

            <Box gridArea="auto" display="flex" justifyContent="center" alignItems="center" cursor="pointer">
                <Text
                    onClick={(e) => {
                        if (label === 'Size') {
                            handleMultipleDelete();
                        } else {
                            handleSingleDelete(e);
                        }
                    }}>
                    <BsXLg />
                </Text>
            </Box>

            <UnorderedList
                 listStyle = 'none'
                 display = 'flex'
                 gap ='1rem'
                 borderTop = '2px solid #F2F4F7'
                 padding = '1rem'
                 paddingBottom = '3rem'
                 >
                {box &&
                    box.map((item, index) => (
                        <li
                            key={index}
                            style={{
                                display: 'flex',
                                gap: '.8rem',
                                padding: '.2rem',
                                paddingInline: '.6rem',
                                borderRadius: '5px',
                                justifyContent: 'center',
                                alignItems: 'center',
                                background: '#F2F4F7',
                            }}>
                            <Text>{item}</Text>
                            {label === 'Size' && (
                                <Text onClick={(e) => handleSingleDelete(e, item)}>
                                    <BsXLg />
                                </Text>
                            )}
                        </li>
                    ))}
            </UnorderedList>
        </Box>
    );
}
